// separate file so the service doesnt get too busy

import { globalFields } from "./global-fields"

const recordTypes = {
    fields: [
      globalFields.charging.id,
      globalFields.charging.recordTypes,
      {
        name: 'recordTypeLabels',
        label: 'Report Types',
        validators: {},
      },
    ],
    customFields: [],
  };

const arrest = {
    fields: [
        globalFields.charging.arrestNumber, //0
        globalFields.charging.arrestType,
        globalFields.charging.ticketNumber,
        globalFields.charging.arrestDate,
        globalFields.charging.arrestDisposition,
        globalFields.charging.arrestingAgency, //5
        {
            name: 'arrestingOfficer',
            label: 'Arresting Officer',
            array: [
                globalFields.charging.arrestingOfficer,
                {
                    name: 'isSaved'
                },
            ]
        },
        globalFields.charging.mirandaDateAndTime,
        globalFields.charging.mirandaBy,
        globalFields.charging.impairmentType,
        globalFields.charging.bac, //10
        {
            name: 'summaryUCRData',
            label: 'Summary UCR Data',
            array: [
                globalFields.charging.UCRCode,
                globalFields.charging.UCRJuvenileDisposition,
                {
                    name: 'summaryId'
                    
                }
            ]
        },
        globalFields.charging.nibrsArrestType,
        globalFields.charging.multipleArrest,
        globalFields.charging.juvenileDisposition,
        globalFields.charging.resident, //15
        globalFields.charging.ageAtTimeIncident,
        globalFields.charging.sex,
        globalFields.charging.race,
        globalFields.charging.ethnicity,
        { //20
            name: 'arms',
            label: 'Arms',
            array: [
                globalFields.charging.value,
                globalFields.charging.automaticWeapon,
                {
                    name: 'attributeId'
                    
                }
            ]
        },
        globalFields.charging.tags,
        globalFields.charging.offenseTrackingNumber,
    ],
    customFields: [

    ]
}

const releaseInformation = {
    fields: [
        {
            name: 'releasedToFirst',   //0
            label: 'First Name',
            validators: {},
          },
          {
            name: 'releasedToMiddle',   
            label: 'Middle Name',
            validators: {},
          },
          {
            name: 'releasedToLast',
            label: 'Last Name',
            validators: {},
          },
          {
            name: 'relationship',
            label: 'Relationship',
            validators: {},
          },
        {
            name: 'releaseDateTime',
            label: 'Release Date/Time',
            validators: {}, 
        },
        {
            name: 'releaseReason', //5
            label: 'Reason',
            validators: {}, 
        },
        {
            name: 'releaseOfficer', 
            label: 'Release Officer',
            validators: {}, 
        },
    ],
    customFields: [

    ]
}

const location = {
  fields: [
    {
      name: 'involvement',
      label: 'Involvement',
      validators: {},
    },
    {
      name: 'isPrimary',
      label: 'Primary',
      validators: {},
    },
    {
      name: 'incidentAndAddressId',
      label: 'incidentAndAddressId',
      validators: {},
    },
  ],
  customFields: [],
}

const violationPrimaryInformation = {
    fields: [
        {
            name: 'citationNumberLabel',   //0
            label: 'Citation Number',
            validators: {},
          },{
            name: 'warningNumberLabel',   //0
            label: 'Warning Number',
            validators: {},
          },
          {
            name: 'parkingTicketNumber',
            label: 'Parking Ticket Number',
            validators: {},
          },
          {
            name: 'nonMovingCitationNumber',
            label: 'Non-Moving Citation Number',
            validators: {},
          },
          {
            name: 'violationNumber',
            label: '', //this holds the value of the 4 fields above, those fields above contain the label
            validators: {required: true,},
          },
        {
            name: 'officer', 
            label: 'Officer',
            validators: {}, 
        },
        {
            name: 'agency', 
            label: 'Agency',
            validators: {}, 
        },
        {
            name: 'dateTime',
            label: 'Occurred On',
            validators: {}, 
        },
        {
            name: 'violationCode',
            label: 'Violation Code',
            validators: {}, 
        },
        {
            name: 'weather',
            label: 'Weather',
            validators: {}, 
        },
        {
            name: 'dueOn',
            label: 'Due On',
            validators: {}, 
        },
        {
            name: 'isComplete',
            label: 'Completed',
            validators: {}, 
        },
        {
            name: 'tags',
            label: 'Tags',
            validators: {},
        },
        {
            name: 'letterSentOn',  
            label: 'Letter Sent On',
            validators: {},
        },
        {
            name: 'citationIssuedOn',  
            label: 'Issued On',
            validators: {},
        }
    ],
    customFields: [

    ]
}

const violationCourtData = {
    fields: [
        {
            name: 'court',   //0
            label: 'Court',
            validators: {},
          },
          {
            name: 'dateTime',  
            label: 'Date | Time',
            validators: {},
          },
          {
            name: 'docketNumber',
            label: 'Docket Number',
            validators: {},
          },
          {
            name: 'disposition',
            label: 'Disposition',
            validators: {},
          },
    ],
    customFields: [

    ]
}

const violationAppearanceTicketData = {
  fields: [
    {
      name: 'id',
      label: 'Appearance Ticket Id',
      validators: {},
    },
    {
      name: 'appearanceNumber',
      label: 'Appearance Number',
      validators: {},
    },
    {
      name: 'courtId',
      label: 'Court Id',
      validators: {},
    },
    {
      name: 'court',
      label: 'Court',
      validators: {},
    },
    {
      name: 'courtTenantId',
      label: 'Court Tenant Id',
      validators: {},
    },
    {
      name: 'courtDocketNumber',
      label: 'Docket Number',
      validators: {},
    },
    {
      name: 'courtDateTime',
      label: 'Date and Time',
      validators: {},
    },
  ],
  customFields: [

  ]
}

const violationSpeedData = {
    fields: [
        {
            name: 'speedMeasured',   //0
            label: 'Measured (mph)',
            validators: {},
          },
          {
            name: 'speedPosted',  
            label: 'Posted (mph)',
            validators: {},
          },
          {
            name: 'speedReasonablePrudent',
            label: 'RP',
            validators: {},
          },
          {
            name: 'speedMeasurementMethod',
            label: 'Measurement Method',
            validators: {},
          },
          
          {
            name: 'speedMeasurementDeviceIdentifier',
            label: 'Device ID',
            validators: {},
          },
    ],
    customFields: [

    ]
}

const violationBloodAlcohol = {
    fields: [
        {
            name: 'bloodAlcoholTestType',   //0
            label: 'Test Type',
            validators: {},
          },
          {
            name: 'bloodAlcoholLevelId',  
            label: 'Results',
            validators: {},
          },
          {
            name: 'bloodAlcoholTestedById',
            label: 'Operator',
            validators: {},
          },
          {
            name: 'bloodAlcoholTestDeviceIdentifier',
            label: 'Machine ID',
            validators: {},
          },
    ],
    customFields: [

    ]
}

const violationFinesCosts = {
    fields: [
        {
            name: 'fine',   //0
            label: 'Fine Amount',
            validators: {},
          },
          {
            name: 'paymentDueOn',  
            label: 'Payment Due Date',
            validators: {},
          },
          {
            name: 'totalAmount',  
            label: 'Total Amount',
            validators: {},
            disabled: true
          },
          {
            name: 'matureDate',  
            label: 'Mature Date',
            validators: {},
          },
          {
            name: 'paidOn',  
            label: 'Paid Date',
            validators: {},
          },
          {
            name: 'paymentStatusId',
            label: 'Payment Status',
            validators: {},
          },
          {
            name: 'paymentTypeId',
            label: 'Payment Type',
            validators: {},
          },
          {
            name: 'checkNumber',
            label: 'Check Number',
            validators: { maxlength: 30, pattern: '^[a-zA-Z0-9]*$' },
          },
          {
            name: 'institution',
            label: 'Institution',
            validators: { maxlength: 200 },
          },
          {
            name: 'additionalFees',
            label: 'Additional Fees/Costs',
            array: [
                {
                    name: 'typeId',   
                    label: 'Type',
                    validators: {},
                },
                {
                    name: 'amount',   
                    label: 'Amount',
                    validators: {},
                  },
            ]
        },
    ],
    customFields: [

    ]
}

const bookingGeneralInformation = {
  fields: [
    {
      name: 'bookingNumber',   //0
      label: 'Booking Number',
      validators: {required: true,},
    },
    {
      name: 'bookedOn',  
      label: 'Booking Date',
      validators: {},
    },
    {
      name: 'bookingOfficerId',  
      label: 'Booking Officer',
      validators: {},
    },
    {
      name: 'transportedBy',  
      label: 'Transported By',
      validators: {},
    },
    {
      name: 'isFingerPrinted',  
      label: 'Is Finger Printed',
      validators: {},
    },
    {
      name: 'isMugshotTaken',  
      label: 'Mugshot Taken',
      validators: {},
    },
    {
      name: 'fbiNumber',  
      label: 'FBI Number',
      validators: {},
    },
    {
      name: 'sbiNumber',  
      label: 'SBI Number',
      validators: {},
    },
    {
      name: 'sbiStateId',  
      label: 'State',
      validators: {},
    },
    {
      name: 'bookingTypeIds',  
      label: 'Booking Types',
      validators: {},
    },
    {
      name: 'agencyIncidentNumber',
      label: 'Agency Incident Number',  
      validators: {maxlength: 50},
    },
    {
      name: 'isInternalIncidentNumber',
      validators: {},
    },
    {
      name: 'dispositionId',  
      label: 'Disposition',
      validators: {},
    },
  ],
  customFields: [

  ]
}

const nonTrafficCitationCourtData = {
  fields: [
      {
          name: 'court',   //0
          label: 'Court',
          validators: {},
        },
        {
          name: 'dateTime',  
          label: 'Date | Time',
          validators: {},
        },
        {
          name: 'docketNumber',
          label: 'Docket Number',
          validators: {},
        },
        {
          name: 'institutedById',
          label: 'Case Instituted By',
          validators: {},
        },
  ],
  customFields: [

  ]
}

const nonTrafficCitationConfidentialInformation = {
  fields: [
      {
          name: 'confidentialInformation',   //0
          label: 'Confidential Information',
          validators: {
            maxlength: 1024
          },
        },
  ],
  customFields: [

  ]
}

const nonTrafficCitationRemark = {
  fields: [
      {
          name: 'remarks',   //0
          label: 'Remarks',
          validators: {
            maxlength: 1024
          },
        },
  ],
  customFields: [

  ]
}


const bookingIllnessAndSickness = {
  fields: [
      {
          name: 'illnessComment',   //0
          label: 'Comment',
          validators: {},
        },
        {
          name: 'medicalTreatmentFacility',  
          label: 'Treatment Facility',
          validators: {},
        },
        {
          name: 'isCheckedForMedicalAlerts',
          label: 'Checked for Medical Alerts',
          validators: {},
        },
        {
          name: 'receivedBloodDraw',
          label: 'Blood Draw Received',
          validators: {},
        },
        {
          name: 'bloodDrawCost',
          label: 'Blood Draw Cost',
          validators: {},
        },
        {
          name: 'isDiabetic',
          label: 'Is Diabetic',
          validators: {},
        },
        {
          name: 'requiresMedication',
          label: 'Requires Medication',
          validators: {},
        },
        {
          name:'physicalConditions',
          label: 'Physical Conditions',
          validators: {}, 
        },
        {
          name:'medicalConditions',
          label: 'Medical Conditions',
          validators: {}, 
        },
        {
          name:'illnesses',
          label: 'Sickness/Illness',
          validators: {}, 
        },
        {
          name:'conditions',
          label: 'Conditions',
          validators: {}, 
        },
        {
          name:'illnessStatuses',
          label: 'Status',
          validators: {},  
        },
        {
          name:'bloodDrawCourt',
          label: 'Court',
          validators: {},  
        }
  ],
  customFields: [

  ]
}

const arrestReportDetaineeProperty = {
  fields: [
      {
          name: 'isInventoryTakenDuringIntake',   //0
          label: 'Taken during intake',
          validators: {},
        },
        {
          name: 'isInventoryTakenByArrestingAgency',  
          label: 'Taken by Arresting Agency',
          validators: {},
        },
        {
          name: 'takenByEmployeeId',
          label: 'Taken/Inventoried By',
          validators: {},
        },
        {
          name: 'witnessedByEmployeeId',
          label: 'Witnessed By',
          validators: {},
        },
        {
          name: 'receiptNumber',   
          label: 'Receipt Number',
          validators: {required: true},
        },
        {
          name: 'properties',
          label: 'Inventory',
          array: [
              {
                name: 'propertyDescription',   
                label: 'Description',
                validators: {},
              },
              {
                name: 'personToReceiveProperty',   
                label: 'Person Authorized to Accept Property',
                validators: {},
              },
              {
                name: 'classId',   
                label: 'Class',
                validators: {},
              },
              {
                name: 'lockerId',   
                label: 'Location',
                validators: {},
              },
              {
                name: 'releasedByEmployeeId',   
                label: 'Released By',
                validators: {},
              },
              {
                name: 'releaseWitnessEmployeeId',   
                label: 'Release Witness',
                validators: {},
              },
              {
                name: 'statedValue',   
                label: 'Value Stated',
                validators: {},
              },
              {
                name: 'isHeld',   
                label: 'Held',
                validators: {},
              },
              {
                name: 'isDisposed',   
                label: 'Disposed',
                validators: {},
              },
              {
                name: 'isReleaseSigned',   
                label: 'Signed Release',
                validators: {},
              },
              {
                name: 'isReleaseRefused',   
                label: 'Unable/Refused Release',
                validators: {},
              },
              {
                name: 'releasedOnDate',   
                label: 'Released On',
                validators: {},
              },
              {
                name: 'releasedToPerson',   
                label: 'Released To',
                validators: {},
              },
              {
                name: 'comment',   
                label: 'Comment',
                validators: {},
              },
          ]
      },
  ],
  customFields: [

  ]
}

const arrestReportBailBond = {
  fields: [
      {
          name: 'bailBondTypeId',   //0
          label: 'Bond Type',
          validators: {required: true},
        },
        {
          name: 'totalBailAmount',  
          label: 'Total Amount',
          validators: {required: true},
        },
        {
          name: 'percentCashRequired',
          label: 'Percent Required', 
        },
        {
          name: 'bailBondOrganizationId',
          label: 'Bail Bond Organization',
        },
        {
          name: 'payments',
          label: 'Payments',
          array: [
              {
                name: 'paymentTypeId',   
                label: 'Type',
                validators: {},
              },
              {
                name: 'paymentMethodId',   
                label: 'Method',
                validators: {},
              }, 
              {
                name: 'amountPaid',   
                label: 'Amount Paid',
                validators: {},
              },
              {
                name: 'amountDue',   
                label: 'Amount Due',
                validators: {},
              },
              {
                name: 'amountRequired',   
                label: 'Amount Required',
                validators: {},
              },
          ]
      },
  ],
  customFields: [

  ]
}

const bookingSystemCheck = {
  fields: [
    {
      name: 'systemCheckTypes',
      label: 'System Check Types',
      array: [
        {
          name: 'systemCheckTypeIds',
          label: 'System Type',
          validators: { required: true, },
        },
        {
          name: 'checkedOn',
          label: 'Checked On',
          validators: { required: true, },
        },
        {
          name: 'checkedByEmployee',
          label: 'Checked By',
          validators: { required: true, },
        },
      ]
    },
    {
      name: 'warrantCourtOrderTypeIds',
      label: 'Warrant/Court Order Type',
      validators: {},
    },
    {
      name: 'isExtraditionRequested',
      label: 'Extradition Requested',
      validators: {},
    },
    {
      name: 'extraditionOrganization',
      label: 'Extradition Organization',
      validators: { maxLength: 50 },
    },
    {
      name: 'extraditionContact',
      label: 'Extradition Contact',
      validators: { maxLength: 50 },
    },
    {
      name: 'systemCheckDocuments',
      label: 'System Check Documents',
      array: [
        {
          name: 'id',
          label: 'System Check Document Id',
          validators: {},
        },
        {
          name: 'documentTypeId',
          label: 'Document Type',
          validators: { required: true, },
        },
        {
          name: 'documentQuantity',
          label: 'Document Quantity',
          validators: { required: true, },
        },
        {
          name: 'documentNumber',
          label: 'Document Number',
          validators: { required: true, },
        },
        {
          name: 'isNCICCancelled',
          label: 'NCIC Cancelled',
          validators: {},
        },
        {
          name: 'isArraigned',
          label: 'Arraigned',
          validators: {},
        },
        {
          name: 'comment',
          label: 'Comment',
          validators: {},
        },
      ]
    },
  ],
  customFields: []
}

const hadngunPermit = {
    fields: [
      {
        name: 'hasHandgun',
        label: 'Has Handgun',
        validators: {},
      },
      {
        name: 'permitNumber',
        label: 'Permit Number',
        validators: {},
      },
      {
        name: 'permitIssuedOn',
        label: 'Permit Issued On',
        validators: {},
      },
    ],
    customFields: [

  ]
}

const specialNeedsAlert = {
  fields: [
    {
      name: 'specialNeedsAlerts',
      label: 'Special Needs Alerts',
      array: [ 
        {
          name: 'specialNeedsTypeId',
          label: 'Special Needs Type',
          validators: { required: true},
        },
        {
          name: 'notedByEmployeeId',
          label: 'Noted By',
          validators: { required: true },
        },
        {
          name: 'reviewedByEmployeeId',
          label: 'Reviewed By',
          validators: {},
        },
        {
          name: 'notifiedOn',
          label: 'Notified On',
          validators: {},
        },
        {
          name: 'comment',
          label: 'Comment',
          validators: { maxLength:250},
        },
        {
          name: 'notifiedUserIds',
          label: 'Notified Users',
          validators: {},
        },
      ],
    },
  ],
  customFields: [
  ]
}

const arrestSearch = {
  fields: [
      {
          name: 'searches',
          label: 'Searches',
          array: [
             {
              name: 'arrestSearchTypeId',
              label: 'Search Type',
              validators: {required: true,},
             },
             {
              name: 'arrestSearchResultId',
              label: 'Search Result',
              validators: {required: true,},
             },
             {
              name: 'searchByEmployeeId',
              label: 'Searched By',
              validators: {required: true,},
             },
             {
              name: 'searchApprovedByEmployeeId',
              label: 'Approved By',
              validators: {},
             },
             {
              name: 'comment',
              label: 'Comment',
              validators: {},
             },
             {
              name: 'searchedOn',
              label: 'Searched On',
              validators: {required: true,},
             }, 
          ]
      },
  ],
  customFields: [

  ]
} 

const prisonerSafetyCheck = {
  fields: [
    {
      name: 'checkTypeIds',
      label: 'Check Type',
    },
    {
      name: 'locationId',
      label: 'Check Location',
      validators: {},
    },
    {
      name: 'behaviorId',
      label: 'Prisoner Behavior',
      validators: {},
    },
    {
      name: 'restraintTypeId',
      label: 'Restraint Type',
      validators: {},
    },
    {
      name: 'approverId',
      label: 'Approver',
      validators: {},
    },
    {
      name: 'checkedById',
      label: 'Checked By',
      validators: { required: true },
    },
    {
      name: 'checkedOn',
      label: 'Checked On',
      validators: { required: true },
    },
    {
      name: 'comment',
      label: 'Notes',
      validators: {},
    },
    {
      name: 'bloodAlcoholContent',
      label: 'BAC',
      validators: {},
    },
    {
      name: 'checkResultIds',
      label: 'Tags',
      validators: {},
    },
    {
      name: 'restraintChairStartDate',
      label: 'Restraint Chair Start Date',
      validators: {},
    },
    {
      name: 'restraintChairEndDate',
      label: 'Restraint Chair End Date',
      validators: {},
    },
    {
      name: 'prisonerSafetyCheckFrequencyId',
      label: 'Frequency',
      validators: {},
    },
    {
      name: 'safetyCheckReasonId',
      label: 'Reason',
      validators: {},
    },
  ],
  customFields: [

]
}


const arrestDetaineeTransfer = {
  fields: [
    {
      name: 'detaineeTransfers',
      label: 'Detainee Transfers',
      array: [
        {
          name: 'id',
          label: 'Detainee Transfer Id',
        },
        {
          name: 'arrestReportId',
          label: 'Arrest Report Id',
        },
        {
          name: 'transferOn',
          label: 'Transfer Date/Time',
        },
        {
          name: 'transferFromOrganizationId',
          label: 'Transferring From Id',
          validators: {},
        },
        {
          name: 'transferFromOrganization',
          label: 'Transferring From',
          validators: {},
        },
        {
          name: 'transferToOrganizationId',
          label: 'Transferring To Id',
          validators: {},
        },
        {
          name: 'transferToOrganization',
          label: 'Transferring To',
          validators: {},
        },
        {
          name: 'transferringOfficers',
          label: 'Transferring Officer(s)',
          validators: {},
        },
        {
          name: 'detaineeTransferAndOfficers',
          label: 'Transferring Officer(s)',
          array: [
            {
              name: 'id',
              label: 'Detainee Transfer And Officer Id',
            },
            {
              name: 'detaineeTransferId',
              label: 'Detainee Transfer Id',
            },
            {
              name: 'tenantId',
              label: 'Tenant Id',
            },
            {
              name: 'officerId',
              label: 'Officer Id',
            },
          ]
        },
        {
          name: 'comment',
          label: 'Comment',
          validators: {},
        },
      ],
    }
  ],
  customFields: []
} 

export const violationPrimaryInformationFields = {
    fields: [...violationPrimaryInformation.fields]
  }

export const violationCourtDataFields = {
    fields: [...violationCourtData.fields]
  }

export const violationAppearanceTicketFields = {
  fields: [...violationAppearanceTicketData.fields]
}

  export const violationSpeedDataFields = {
    fields: [...violationSpeedData.fields]
  }
  export const violationBloodAlcoholFields = {
    fields: [...violationBloodAlcohol.fields]
  }
  export const violationFinesCostsFields = {
    fields: [...violationFinesCosts.fields]
  }
export const releaseInformationFields = {
    fields: [...releaseInformation.fields],
    customFields: [...releaseInformation.customFields]
}

export const arrestFields = {
    fields: [...arrest.fields],
    customFields: [...arrest.customFields]
}

export const recordTypesFields = {
    fields: [...recordTypes.fields],
    customFields: [...recordTypes.customFields]
}

export const bookingGeneralInformationFields = {
  fields: [...bookingGeneralInformation.fields],
  customFields: [...bookingGeneralInformation.customFields]
}

export const nonTrafficCitationCourtDataFields = {
  fields: [...nonTrafficCitationCourtData.fields],
  customFields: [...nonTrafficCitationCourtData.customFields]
}

export const nonTrafficCitationConfidentialInformationFields = {
  fields: [...nonTrafficCitationConfidentialInformation.fields],
  customFields: [...nonTrafficCitationConfidentialInformation.customFields]
}

export const nonTrafficCitationRemarkFields = {
  fields: [...nonTrafficCitationRemark.fields],
  customFields: [...nonTrafficCitationRemark.customFields]
}

export const bookingIllnessAndSicknessFields = {
  fields: [...bookingIllnessAndSickness.fields],
  customFields: [...bookingIllnessAndSickness.customFields]
}

export const chargingLocationFields = {
  fields: [...location.fields],
  customFields: [...location.customFields]
}

export const arrestReportDetaineePropertyFields = {
  fields: [...arrestReportDetaineeProperty.fields],
  customFields: [...arrestReportDetaineeProperty.customFields]
}

export const arrestReportBailBondFields = {
  fields: [...arrestReportBailBond.fields],
  customFields: [...arrestReportBailBond.customFields]
}

export const bookingSystemCheckFields = {
  fields: [...bookingSystemCheck.fields],
  customFields: [...bookingSystemCheck.customFields]
}

export const hadngunPermitFields = {
  fields: [...hadngunPermit.fields],
  customFields: [...hadngunPermit.customFields]
}

export const specialNeedsAlertFields = {
  fields: [...specialNeedsAlert.fields],
  customFields: [...specialNeedsAlert.customFields]
}

export const arrestSearchFields = {
  fields: [...arrestSearch.fields],
  customFields: [...arrestSearch.customFields]
}

export const prisonerSafetyCheckFields = {
  fields: [...prisonerSafetyCheck.fields],
  customFields: [...prisonerSafetyCheck.customFields]
}

export const arrestDetaineeTransferFields = {
  fields: [...arrestDetaineeTransfer.fields],
  customFields: [...arrestDetaineeTransfer.customFields]
}